// 코스메틱 UI 테마 — CSS 변수와 프리즘 렌더링은 UI 경계에 둔다.
import type { Grade } from '@core/sim/cosmetic/cosmeticCatalog';

export const GRADE_THEME: Record<Grade, { color: string; soft: string }> = {
  N: { color: 'var(--cs-mute)', soft: 'var(--cs-surface-2)' },
  R: { color: 'var(--cs-fall)', soft: 'var(--cs-fall-soft)' },
  E: { color: 'var(--cs-gold)', soft: 'var(--cs-gold-soft)' },
  L: { color: 'var(--cs-alert)', soft: 'var(--cs-alert-soft)' },
};

/** L 전용 프리즘 테두리 — 기존 토큰 3색 조합(새 색 0) */
export const PRISM_GRADIENT = 'linear-gradient(135deg, var(--cs-gold), var(--cs-alert), var(--cs-fall))';
